import { IRoute } from '../entities/interfaces/route';
import { lazy } from 'react';

export const routes: IRoute[] = [
  {
    path: '/choose',
    component: lazy(() => import('../pages/ChooseExercise/ChooseExercise')),
    exact: true,
    private: false,
    fallback: null
  },
  {
    path: '/player/:student/exercise/:playlist',
    component: lazy(() => import('../pages/TerminalExercise/TerminalExercise')),
    exact: true,
    private: false,
    fallback: null
  },
  {
    path: '/maintenance',
    component: lazy(() => import('../pages/Maintenance/Maintenance')),
    exact: true,
    private: false,
    fallback: null
  },
  {
    path: '*',
    component: lazy(() => import('../pages/Error404/Error404')),
    exact: false,
    private: false,
    fallback: null
  }
];
